/* eslint-disable @typescript-eslint/naming-convention */
import { Building } from '../booking/building.model';
import { Country } from './country.model';

export class Member {
  c?: any;
  cost_center?: string;
  country?: Country | string;
  createdAt?: string;
  display_name?: string;
  email?: string;
  firstName?: string;
  given_name?: string[];
  id?: string;
  lastName?: string;
  mail?: string[];
  mobile?: string[];
  phoneNumber?: string;
  picture?: string;
  preferred_language?: string;
  role?: string;
  roles?: string[];
  rolesUpdatedAt?: string;
  sn?: string[];
  title?: string[];
  uid?: string;
  uuid?: string;
  workplace?: Building | string;

  constructor(values: any = {}) {
    if (values !== null) {
      Object.assign(this, values);

      if (values.ldapData) {
        Object.assign(this, values.ldapData);
      }
    }
  }

  getEmail(): string {
    if (!this.email && !this.mail) {
      return '';
    }

    return this.email ? this.email : this.mail[0];
  }

  /**
   * Returns first name of this member
   */
  getFirstName(): string {
    if (!this.firstName && !this.given_name) {
      return '';
    }

    return this.firstName ? this.firstName : this.given_name[0];
  }

  /**
   * Returns this user's full name used for displaying information
   */
  getFullName(): string {
    if (this.display_name) {
      return this.display_name;
    } else {
      return `${this.firstName} ${this.lastName}`;
    }
  }

  /**
   * Returns last name of this member
   */
  getLastName(): string {
    if (!this.lastName && !this.sn) {
      return '';
    }

    return this.lastName ? this.lastName : this.sn[0];
  }

  getShortCodeCenter(): string {
    let shortCode: string;
    shortCode = this.cost_center;
    shortCode = shortCode.slice(0, shortCode.length - 4);
    shortCode = shortCode.slice(shortCode.length - 10, shortCode.length);
    return shortCode;
  }

  getUuid(): string {
    return this.uuid ?? this.id;
  }

  toString() {
    return this.getFullName();
  }
}
